module.exports = __webpack_public_path__ + "img/img_product_top@2x.852b725b.png";